import { render, staticRenderFns } from "./ProcurementRequestForMaterialItem.vue?vue&type=template&id=9afb954a&"
import script from "./ProcurementRequestForMaterialItem.vue?vue&type=script&lang=js&"
export * from "./ProcurementRequestForMaterialItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports